export const identity = {
  name: 'steamed',
  handle: '@steamed',
  email: '[EMAIL]',
  discord: '@steamed',
  role: 'Trading systems developer',
  lead: 'Trading infrastructure in TypeScript.',
} as const;

export const story = {
  opening: "I'm a 20 year old developer from Australia and I understand markets.",
  paragraphs: [
    "I'm self-taught, I code mostly TypeScript/Node, I'm familiar with Python too, and I build trading infrastructure.",
    'Specifically exchange integrations (using Bybit and Binance APIs), dashboards, indicators/alerts, backtesters, copytrader systems with pnl tracking and full analytics.',
    "I've also built full prop firm mockups that replicated the real eval mechanics, an automatic crypto payment bot for Discord with subscriptions and role grants, and on-chain analysis tooling across ETH/BSC/Base/Solana.",
  ],
  markets:
    'I am comfortable with perp and futures mechanics, funding, fees, margin, liquidation, and I handle my own Linux deployments.',
  closing: [
    "I'm fluent in English, I'm available for 8+ hours of the day, I have a bachelor's degree in Computer Science and I'm currently taking more classes for it.",
    "I have been using Anthropic/Claude since it came out, and I use AI in my workflows to increase production speed whilst reviewing the code myself to make sure it's up to standard and deployable.",
    "I also create mock-ups and designs myself rather than using AI to make sure it's authentic and not \u201cslop\u201d.",
  ],
} as const;
